/*

  The central source of all typography styles.
  This should always match the Figma File "Type System June '20"
  Figma URL - https://www.figma.com/file/dx4VAZwqg1GK3N46oh10dg/Type-System-June'20
  Last Updated - "Tue May 04 2021 00:52:48 GMT+0530 (India Standard Time)"

*/


export const TYPE_LABELS = {
	DISPLAY_LARGE: "Display/Large",
	DISPLAY_REGULAR: "Display/Regular",
	DISPLAY_SMALL: "Display/Small",
	HEADING_LARGE: "Heading/Large",
	HEADING_REGULAR: "Heading/Regular",
	HEADING_SMALL: "Heading/Small",
	HEADING_XS: "Heading/XS",
	HEADING_PRODUCT_CARD: "Heading/Product Card",
	SUBHEADING_LARGE: "Subheading/Large",
	SUBHEADING_REGULAR: "Subheading/Regular",
	SUBHEADING_SMALL: "Subheading/Small",
	SUBHEADING_XS: "Subheading/XS",
	BUTTON_BIG: "Button/Big",
	BUTTON_MEDIUM: "Button/Medium",
	BUTTON_SMALL: "Button/Small",
	UI_LABEL_LARGE: "UI/Label Large",
	UI_LABEL_MEDIUM: "UI/Label Medium",
	UI_LABEL_REGULAR: "UI/Label Regular",
	UI_LABEL_SMALL: "UI/Label Small",
	UI_LABEL_XS: "UI/Label XS",
	UI_LABEL_CAPTION: "UI/Label Caption",
	UI_LABEL_LARGE_HEAVY: "UI/Label Large (Heavy)",
	UI_LABEL_MEDIUM_HEAVY: "UI/Label Medium (Heavy)",
	UI_LABEL_REGULAR_HEAVY: "UI/Label Regular (Heavy)",
	UI_LABEL_SMALL_HEAVY: "UI/Label Small (Heavy)",
	PARAGRAPH_LARGE: "Paragraph/Large",
	PARAGRAPH_MEDIUM: "Paragraph/Medium",
	PARAGRAPH_REGULAR: "Paragraph/Regular",
	PARAGRAPH_SMALL: "Paragraph/Small",
	PARAGRAPH_XS: "Paragraph/XS",
	PARAGRAPH_CAPTION: "Paragraph/Caption",
	PARAGRAPH_BLOCKQUOTE: "Paragraph/Blockquote",
	LIST_SMALL: "List/Small",
	LIST_REGULAR: "List/Regular",
	LIST_MEDIUM: "List/Medium",
	LIST_LARGE: "List/Large",
	MISC_OVERLINE_LARGE: "Misc/Overline Large",
	MISC_OVERLINE: "Misc/Overline",
	MISC_TAG_HEAVY: "Misc/Tag Heavy",
	MISC_TAG_MEDIUM: "Misc/Tag Medium",
	MISC_TAG_REGULAR: "Misc/Tag Regular",
	MISC_BADGE_SMALL: "Misc/Badge Small",
	MISC_BOOSTER: "Misc/Booster",
	TABLE_MEDIUM_HEAVY: "Table/Medium (Heavy)",
	TABLE_MEDIUM: "Table/Medium",
	TABLE_REGULAR_HEAVY: "Table/Regular (Heavy)",
	TABLE_REGULAR: "Table/Regular",
	TABLE_LARGE_HEAVY: "Table/Large (Heavy)",
	TABLE_LARGE: "Table/Large",
	TABLE_SMALL_HEAVY: "Table/Small (Heavy)",
	TABLE_SMALL: "Table/Small"
};

const FONT_FAMILY = {
	HALYARD: {
		DISPLAY: 'halyard-display, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
		TEXT: 'halyard-text, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
	}
}

const typography = {
  [TYPE_LABELS.DISPLAY_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 48,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 54,
    lineHeightPercent: 113,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.DISPLAY_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 36,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 44,
    lineHeightPercent: 122,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.DISPLAY_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 30,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 38,
    lineHeightPercent: 127,
    letterSpacing: 0.4,
  },
  [TYPE_LABELS.HEADING_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 24,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 28,
    lineHeightPercent: 117,
    letterSpacing: 0.8,
  },
  [TYPE_LABELS.HEADING_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 21,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 28,
    lineHeightPercent: 133,
    letterSpacing: 0.8,
  },
  [TYPE_LABELS.HEADING_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 18,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 24,
    lineHeightPercent: 133,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.HEADING_XS]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 15,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 133,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.HEADING_PRODUCT_CARD]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 17,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 118,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.SUBHEADING_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 125,
    letterSpacing: 0,
  },
  [TYPE_LABELS.SUBHEADING_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 143,
    letterSpacing: 0,
  },
  [TYPE_LABELS.SUBHEADING_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.SUBHEADING_XS]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.BUTTON_BIG]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 20,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 24,
    lineHeightPercent: 120,
    letterSpacing: 0.8,
  },
  [TYPE_LABELS.BUTTON_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 125,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.BUTTON_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 114,
    letterSpacing: 0.2,
  },
  [TYPE_LABELS.UI_LABEL_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 118,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 114,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_XS]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 10,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 120,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_CAPTION]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 11,
    fontWeight: 300,
    fontStyle: 'italic',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 109,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_LARGE_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 118,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_MEDIUM_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_REGULAR_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 114,
    letterSpacing: 0,
  },
  [TYPE_LABELS.UI_LABEL_SMALL_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 28,
    lineHeightPercent: 165,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 24,
    lineHeightPercent: 160,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 143,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 167,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_XS]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 10,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 160,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_CAPTION]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 11,
    fontWeight: 300,
    fontStyle: 'italic',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 145,
    letterSpacing: 0,
  },
  [TYPE_LABELS.PARAGRAPH_BLOCKQUOTE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 300,
    fontStyle: 'italic',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 143,
    letterSpacing: 0,
  },
  [TYPE_LABELS.LIST_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 167,
    letterSpacing: 0,
  },
  [TYPE_LABELS.LIST_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 20,
    lineHeightPercent: 143,
    letterSpacing: 0,
  },
  [TYPE_LABELS.LIST_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 24,
    lineHeightPercent: 160,
    letterSpacing: 0,
  },
  [TYPE_LABELS.LIST_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 28,
    lineHeightPercent: 165,
    letterSpacing: 0,
  },
  [TYPE_LABELS.MISC_OVERLINE_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0.6,
  },
  [TYPE_LABELS.MISC_OVERLINE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 120,
    letterSpacing: 0.8,
  },
  [TYPE_LABELS.MISC_TAG_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 13,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 92,
    letterSpacing: 0.4,
  },
  [TYPE_LABELS.MISC_TAG_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 13,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 92,
    letterSpacing: 0.1,
  },
  [TYPE_LABELS.MISC_TAG_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 11,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 109,
    letterSpacing: 0.2,
  },
  [TYPE_LABELS.MISC_BADGE_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 10,
    fontWeight: 400,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 120,
    letterSpacing: 0.2,
  },
  [TYPE_LABELS.MISC_BOOSTER]: {
    fontFamily: FONT_FAMILY.HALYARD.DISPLAY,
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: 'normal',
    lineHeight: 12,
    lineHeightPercent: 120,
    letterSpacing: 1,
  },
  [TYPE_LABELS.TABLE_MEDIUM_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1 'LNUM' 1 'TNUM' 1",
    lineHeight: 20,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_MEDIUM]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 15,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1 'LNUM' 1 'TNUM' 1",
    lineHeight: 20,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_REGULAR_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'LNUM' 1 'TNUM' 1",
    lineHeight: 16,
    lineHeightPercent: 114,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_REGULAR]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 14,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'LNUM' 1 'TNUM' 1",
    lineHeight: 16,
    lineHeightPercent: 114,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_LARGE_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1",
    lineHeight: 20,
    lineHeightPercent: 118,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_LARGE]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 17,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'SS04' 1 'LNUM' 1 'TNUM' 1",
    lineHeight: 20,
    lineHeightPercent: 118,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_SMALL_HEAVY]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 500,
    fontStyle: 'normal',
    fontFeatureSettings: "'LNUM' 1 'TNUM' 1",
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
  [TYPE_LABELS.TABLE_SMALL]: {
    fontFamily: FONT_FAMILY.HALYARD.TEXT,
    fontSize: 12,
    fontWeight: 300,
    fontStyle: 'normal',
    fontFeatureSettings: "'LNUM' 1 'TNUM' 1",
    lineHeight: 16,
    lineHeightPercent: 133,
    letterSpacing: 0,
  },
};

// can add another one to accommodate RNW down the line
export default function getFontDetailsByLabel(label = 'Paragraph/Large') {
  const {
    fontFamily,
    fontSize,
    fontWeight,
    fontStyle,
    fontFeatureSettings,
    lineHeight,
    letterSpacing,
  } = typography[label.trim()];

  const css = `
	font-family: ${fontFamily};
	font-size: ${fontSize}px;
	font-weight: ${fontWeight};
	font-style: ${fontStyle};
	font-feature-settings: ${fontFeatureSettings};
	line-height: ${lineHeight}px;
	letter-spacing: ${letterSpacing}px;
  `;

  return css;
}